import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, HandCoins } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { jamaahApi } from "@/lib/jamaahApi";
import { rupiah, tanggal } from "@/lib/format";

const STATUS = {
  menunggu: ["Menunggu", "bg-amber-100 text-amber-800"],
  dikonfirmasi: ["Dikonfirmasi", "bg-emerald-100 text-emerald-800"],
  ditolak: ["Ditolak", "bg-red-100 text-red-800"],
};
const TYPES = { infaq: "Infaq", sedekah: "Sedekah", zakat: "Zakat", pembangunan: "Dana Pembangunan" };

export const DonasiSaya = () => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    jamaahApi.get("/jamaah/me/donations").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  const total = (items || []).filter((d) => d.status === "dikonfirmasi").reduce((s, d) => s + d.amount, 0);

  return (
    <div className="space-y-5" data-testid="portal-donasi">
      <div className="rounded-2xl emerald-bg text-white p-6 flex items-center justify-between">
        <div>
          <p className="text-xs uppercase tracking-widest text-[#80b996] font-semibold">Total donasi dikonfirmasi</p>
          <p className="mt-1 text-3xl font-extrabold gold-text" data-testid="donasi-total">{rupiah(total)}</p>
        </div>
        <div className="flex items-center gap-4">
          <HeartHandshake size={40} className="text-[#d4af37]/70 hidden sm:block" />
          <Link to="/donasi" className="inline-flex items-center gap-2 rounded-full bg-[#d4af37] text-emerald-950 font-semibold px-5 py-2.5 hover:bg-[#e2c15a] transition-colors text-sm" data-testid="donasi-sekarang-btn">
            <HandCoins size={16} /> Donasi Sekarang
          </Link>
        </div>
      </div>
      <div className="rounded-2xl border border-emerald-900/10 bg-white overflow-hidden">
        {items === null ? (
          <p className="p-6 text-sm text-slate-500">Memuat...</p>
        ) : items.length === 0 ? (
          <p className="p-8 text-center text-sm text-slate-500" data-testid="donasi-empty">Belum ada donasi tercatat atas nomor HP Anda. Cantumkan nomor HP yang sama saat berdonasi agar tercatat di sini.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-emerald-50 text-emerald-900 text-left">
              <tr><th className="px-4 py-3">Tanggal</th><th className="px-4 py-3">Jenis</th><th className="px-4 py-3">Nominal</th><th className="px-4 py-3">Status</th></tr>
            </thead>
            <tbody>
              {items.map((d) => {
                const [label, cls] = STATUS[d.status] || [d.status, ""];
                return (
                  <tr key={d.id} className="border-t border-emerald-900/5" data-testid={`donasi-row-${d.id}`}>
                    <td className="px-4 py-3 text-slate-600">{tanggal(d.date)}</td>
                    <td className="px-4 py-3">{TYPES[d.type] || d.type}</td>
                    <td className="px-4 py-3 font-semibold text-emerald-950">{rupiah(d.amount)}</td>
                    <td className="px-4 py-3"><Badge className={cls}>{label}</Badge></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
